module.exports = __webpack_public_path__ + "static/landscape-442574a7f5a51f728329149876d58732.svg";